module.exports = __webpack_public_path__ + "static/media/rideMidground.159617d5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/CommitView/Ride/rideMidground.svg
// module id = 920
// module chunks = 0